module.exports = __webpack_public_path__ + "img/sz-footer-logo.399a0f59.png";